import PropTypes from "prop-types"
import React from "react"
import { usePressArticles } from "services/graphQl/queries/pressArticles"
import { optimizeContentfulImage } from "utils/optimizeContentfulImage"
import { ArrowUpRight } from "views/press/icons"
import "./press-cards-v2.scss"

// Ordered List display style "Press Cards", first used on /about. Shows the
// Press Articles the list links, in its order; with none linked, the newest.
const DEFAULT_COUNT = 4

const PressCardsV2 = ({ itemIds, title }) => {
  const articles = usePressArticles()
  const byId = new Map(articles.map(article => [article.id, article]))
  const picked = itemIds.map(id => byId.get(id)).filter(Boolean)
  const shown = picked.length ? picked : articles.slice(0, DEFAULT_COUNT)
  if (!shown.length) return null

  return (
    <section className="press-cards-v2">
      <div className="container-v2">
        <div className="press-cards-v2--header">
          {title && <h2 className="press-cards-v2--title">{title}</h2>}
          <a className="press-cards-v2--all" href="/press">
            See all press <span aria-hidden="true">&rarr;</span>
          </a>
        </div>
        <ul className="press-cards-v2--list">
          {shown.map(article => (
            <li className="press-cards-v2--card" key={article.id}>
              <a
                className="press-cards-v2--link"
                href={article.articleLink}
                rel="noopener noreferrer"
                target="_blank"
              >
                <div className="press-cards-v2--image">
                  {article.image?.file?.url && (
                    <img
                      alt={article.image.description || ""}
                      loading="lazy"
                      src={optimizeContentfulImage(
                        `https:${article.image.file.url}`,
                        { width: 640, height: 400 }
                      )}
                    />
                  )}
                </div>
                <div className="press-cards-v2--body">
                  <h3 className="press-cards-v2--card-title">
                    <span>{article.title}</span>
                    <ArrowUpRight size={16} />
                  </h3>
                  {article.summary?.summary && (
                    <p className="press-cards-v2--summary">
                      {article.summary.summary}
                    </p>
                  )}
                  <p className="press-cards-v2--publication">
                    {article.publication}
                  </p>
                  <span className="sr-only">(opens in a new tab)</span>
                </div>
              </a>
            </li>
          ))}
        </ul>
      </div>
    </section>
  )
}

PressCardsV2.propTypes = {
  itemIds: PropTypes.arrayOf(PropTypes.string).isRequired,
  title: PropTypes.string,
}

export default PressCardsV2
